import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom/cjs/react-router-dom.min";
import { Spin, Row, Col, Button } from "antd";
import JoditEditor from "jodit-pro-react";

import CustomScrollbars from "../../../../../../util/CustomScrollbars";

import sessionService from "../../../../../../services/session/sessionService";

import {
  ArrowLeftOutlined,
  ArrowRightOutlined,
  CheckCircleTwoTone,
  ClockCircleTwoTone,
  CloseCircleTwoTone,
  StopTwoTone,
} from "@ant-design/icons";

const editorConfig = {
  license: process.env.REACT_APP_JODIT_PRO_LICENSE_KEY,
  readonly: true,
  defaultActionOnPaste: "insert_as_html",
  defaultLineHeight: 1.5,
  placeholder: "Enter Answer",
  toolbarAdaptive: false,
  toolbarButtonSize: "small",
  height: 200,
  width: "95%",
  buttons:
    "bold, italic, |, ul, ol, |, font, fontsize, |, outdent, indent, align, |, hr, |, fullsize, brush, |, table, link, |, undo, redo,",
};

const user = sessionService.getLoggedUserData();

class PracticeTestPreview extends Component {
  formRef = React.createRef();

  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      visible: false,
      hintused: false,
      answerresp: "",
      attempted: [],
      attemptedindex: 0,
      questionDetail: {},
      answerDetail: {},
      iscorrect: null,
      enteredAnswer: "",
    };
  }

  async componentDidMount() {
    const { getAttemptedQuestion } = this.props;

    window.addEventListener("keydown", this.handleKeyDown);

    const attempted = await getAttemptedQuestion();

    if (attempted.length === 0) return;

    this.setState({
      loading: true,
      username: user.firstname + " " + user.lastname,
      attempted: attempted,
      attemptedindex: 0,
      total: attempted.length,
    });

    const result = attempted[0];

    this.setState({
      loading: false,
      questionDetail: result?.questionDetail,
      answerDetail: result?.answerDetail,
      enteredAnswer: result?.studentanswer,
      iscorrect: result?.iscorrect ?? null,
    });
  }

  handleKeyDown = (event) => {
    if (event.keyCode === 13 || event.key === "Enter") {
      this.handleNext();
    }
  };

  async componentWillUnmount() {
    window.removeEventListener("keydown", this.handleKeyDown);
  }

  handleNext = async () => {
    const { attempted, attemptedindex } = this.state;

    if (attemptedindex === attempted.length - 1) {
      await this.props.hideReviewPage();
      return;
    }

    const data = attempted[attemptedindex + 1];

    this.setState({
      questionDetail: data.questionDetail,
      answerDetail: data.answerDetail,
      enteredAnswer: data.studentanswer,
      attemptedindex: attemptedindex + 1,
      iscorrect:
        data.iscorrect === false && data.studentanswer === ""
          ? null
          : data.iscorrect,
    });
  };

  handleBack = async () => {
    const { attempted, attemptedindex } = this.state;

    const data = attempted[attemptedindex - 1];

    this.setState({
      questionDetail: data.questionDetail,
      answerDetail: data.answerDetail,
      enteredAnswer: data.studentanswer,
      attemptedindex: attemptedindex - 1,
      iscorrect: data.iscorrect ?? null,
    });
  };

  render() {
    const data = this.state.questionDetail;
    const { enteredAnswer, loading, attemptedindex, iscorrect } = this.state;

    if (loading) {
      return <Spin style={{ paddingTop: "10%", paddingLeft: "50%" }} />;
    }

    return (
      <React.Fragment>
        <div className="ant-card-body">
          <div className="questions">
            <div className="question">
              <div className="ant-row">
                <div className="ant-col-24 ant-col-md-14 mx-auto quiz-custom-col">
                  <div className="question-text">
                    <div
                      style={{ marginTop: "-150px" }}
                      className="gx-timeline-badge gx-bg-primary question-no"
                    >
                      {attemptedindex + 1}
                    </div>

                    <div style={{ fontSize: "16px" }}>Question</div>

                    <br />

                    <div className="gx-main-content">
                      {data.passage && data.passage !== "" ? (
                        <Row span={24}>
                          <Col span={12}>
                            <CustomScrollbars
                              className={
                                data.passage?.length < 500
                                  ? "gx-wall-scroll3"
                                  : "gx-wall-scroll2"
                              }
                            >
                              <span
                                dangerouslySetInnerHTML={{
                                  __html: data.passage,
                                }}
                              />
                            </CustomScrollbars>
                          </Col>
                          <Col span={12}>
                            <CustomScrollbars
                              className={
                                data.passage?.length < 500
                                  ? "gx-wall-scroll3"
                                  : "gx-wall-scroll2"
                              }
                            >
                              <span
                                dangerouslySetInnerHTML={{
                                  __html: data.question_html,
                                }}
                              />
                            </CustomScrollbars>
                          </Col>
                        </Row>
                      ) : (
                        <Row span={24}>
                          <Col span={24}>
                            <CustomScrollbars
                              className={
                                data.question_html?.length < 500
                                  ? "gx-wall-scroll3"
                                  : "gx-wall-scroll2"
                              }
                            >
                              <span
                                dangerouslySetInnerHTML={{
                                  __html: data.question_html,
                                }}
                              />
                            </CustomScrollbars>
                          </Col>
                        </Row>
                      )}
                    </div>
                  </div>

                  {iscorrect !== undefined && (
                    <>
                      <div style={{ fontSize: "16px" }}>Correct Answer</div>
                      <div
                        className="input-sec answer-textbox"
                        dangerouslySetInnerHTML={{
                          __html: data.answer_html,
                        }}
                        readOnly={true}
                        type="text"
                      />
                    </>
                  )}

                  <div style={{ fontSize: "16px", marginTop: 20 }}>
                    Your Answer
                  </div>
                  <div className="input-sec answer-text">
                    {data.answertype &&
                    data.answertype === "MCQ" &&
                    data.mcqAnswerOptions &&
                    data.mcqAnswerOptions.length > 0 ? (
                      data.mcqAnswerOptions.map((item, index) => {
                        return (
                          <Button
                            className={
                              item.toLowerCase() === enteredAnswer.toLowerCase()
                                ? "gx-btn-success-dark gx-mr-2"
                                : "ant-btn-ghost gx-mr-2"
                            }
                          >
                            {item}
                          </Button>
                        );
                      })
                    ) : (
                      <JoditEditor
                        value={enteredAnswer}
                        html
                        config={editorConfig}
                      />
                    )}
                  </div>

                  <div
                    style={{
                      fontSize: "16px",
                      marginTop: 20,
                    }}
                  >
                    Your Answer is
                  </div>
                  <div className="input-sec answer-text">
                    {iscorrect === null && (
                      <Button
                        type={"text"}
                        style={{
                          backgroundColor: "#fff",
                          borderColor: "#ff0000",
                        }}
                      >
                        Not Attempted <StopTwoTone twoToneColor={"#ff0000"} />
                      </Button>
                    )}

                    {iscorrect === undefined && (
                      <Button
                        type={"text"}
                        style={{
                          backgroundColor: "#fff",
                          borderColor: "yellow",
                        }}
                      >
                        Waiting for Professor to Grade
                        <ClockCircleTwoTone twoToneColor={"#ffff00"} />
                      </Button>
                    )}

                    {iscorrect === false && (
                      <Button
                        type={"text"}
                        style={{
                          backgroundColor: "#fff",
                          borderColor: "#ff0000",
                        }}
                      >
                        Incorrect{" "}
                        <CloseCircleTwoTone twoToneColor={"#ff0000"} />
                      </Button>
                    )}

                    {iscorrect === true && (
                      <Button
                        type={"text"}
                        style={{
                          backgroundColor: "#fff",
                          borderColor: "greenyellow",
                        }}
                      >
                        Correct
                        <CheckCircleTwoTone twoToneColor={"#52f900"} />
                      </Button>
                    )}
                  </div>

                  {data.explanation_html !== "" &&
                    data.explanation_html !== null &&
                    data.explanation_html !== undefined && (
                      <>
                        <div style={{ fontSize: "16px", fontWeight: "500" }}>
                          Explanation
                        </div>
                        <div
                          className="input-sec answer-textbox"
                          dangerouslySetInnerHTML={{
                            __html: data.explanation_html,
                          }}
                          readOnly={true}
                          type="text"
                        />
                      </>
                    )}

                  {/* add space */}
                  <div style={{ height: 20 }}></div>

                  <div className="cta">
                    <Button
                      type="primary"
                      style={{
                        float: "right",
                        marginLeft: 10,
                      }}
                      onClick={this.handleNext}
                    >
                      {data.total === 1 ? "Finish" : "Next"}
                      <ArrowRightOutlined
                        style={{
                          color: "white",
                        }}
                      />
                    </Button>

                    <Button
                      type="primary"
                      style={{
                        float: "right",
                        marginLeft: 10,
                        display: attemptedindex !== 0 ? "block" : "none",
                      }}
                      onClick={this.handleBack}
                    >
                      <ArrowLeftOutlined
                        style={{
                          color: "white",
                        }}
                      />
                      Back
                    </Button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state) => ({});

const mapDispatchToProps = {};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(PracticeTestPreview)
);
